
export default function LocationMap() {
  return (
    <section className="bg-gray-50 py-16 pb-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8">
          <h2 className="text-2xl font-light text-gray-900 mb-3">
            Our Locations
          </h2>
          <p className="text-gray-600 font-light max-w-2xl mx-auto">
            Visit us at our New York office or China manufacturing facility
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {/* New York Office */}
          <div className="bg-white border border-gray-200 p-6">
            <div className="flex items-center mb-4">
              <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mr-4">
                <i className="ri-building-line text-blue-600 text-xl"></i>
              </div>
              <div>
                <h3 className="text-lg font-medium text-gray-900 mb-1">New York Office</h3>
                {/* <p className="text-gray-600 font-light text-sm">North America Sales Team</p> */}
              </div>
            </div>
            <div className="text-gray-600 font-light text-sm">
              <div className="flex items-center">
                {/* <i className="ri-map-pin-line text-gray-400 mr-2"></i> */}
                {/* <p>350 Fifth Avenue, New York, NY 10118, USA</p> */}
              </div>
            </div>
          </div>

          {/* China Factory */}
          <div className="bg-white border border-gray-200 p-6">
            <div className="flex items-center mb-4">
              <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mr-4">
                <i className="ri-building-2-line text-green-600 text-xl"></i>
              </div>
              <div>
                <h3 className="text-lg font-medium text-gray-900 mb-1">Xinji HuaXin Fur Co., Ltd</h3>
                {/* <p className="text-gray-600 font-light text-sm">Manufacturing Facility, China</p> */}
              </div>
            </div>
            <div className="text-gray-600 font-light text-sm">
              <div className="flex items-center">
                <i className="ri-map-pin-line text-gray-400 mr-2"></i>
                <p>Gongye Road, Maoying Tannery District, Xinji, Hebei, China 052360</p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-10 text-center">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
            <div className="text-center min-w-0">
              <h3 className="text-base font-medium text-gray-900 mb-2">Quick Response</h3>
              <p className="text-gray-600 font-light text-sm whitespace-nowrap">
                We respond to all inquiries within 24 hours
              </p>
            </div>
            <div className="text-center min-w-0">
              <h3 className="text-base font-medium text-gray-900 mb-2">Global Reach</h3>
              <p className="text-gray-600 font-light text-sm whitespace-nowrap">
                Serving clients worldwide with local expertise
              </p>
            </div>
            <div className="text-center min-w-0">
              <h3 className="text-base font-medium text-gray-900 mb-2">Expert Support</h3>
              <p className="text-gray-600 font-light text-sm whitespace-nowrap">
                Dedicated team ready to assist your projects
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
